import { useEffect, useState } from 'react';

/**
 * Retorna true quando a largura da janela é menor ou igual ao breakpoint.
 * Usado para trocar tabelas por cards em telas pequenas (celular/tablet retrato).
 *
 * Padrão 768px — mesmo breakpoint já usado no Calendar de cupos (MobileListView)
 * e na Central de mensagens, para o sistema inteiro virar card no mesmo ponto.
 *
 * Diferença para os dois: aqui usa matchMedia com listener, então reage a
 * rotação de tela e resize (o Calendar lê innerWidth uma vez só via useRef). (2026-08)
 */
export default function useIsNarrow(maxWidth = 768) {
  const query = `(max-width: ${maxWidth}px)`;
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setNarrow(e.matches);
    setNarrow(mql.matches);
    // Safari antigo não tem addEventListener em MediaQueryList
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return narrow;
}
